<template>
    <component
        :is="type"
        :to="to"
        :class="['link-hover', hoverEnable && 'is-hover-enable']"
    >
        <span :class="['link-hover_default', classNames.default && classNames.default ]">
            <slot/>
        </span>
        <span
            :class="['link-hover_hover', classNames.hover && classNames.hover ]"
        >
            <span :class="['link-hover_mask', classNames.hoverMask && classNames.hoverMask ]">
                <slot name="hover"/>
            </span>
        </span>
    </component>
</template>

<script>
export default {
    props: {
        hoverEnable: { type: Boolean, default: true },
        type: { type: String, default: 'a' },
        to: Object | String,
        classNames: { // Curstom class names to target elements from parents
            type: Object,
            default() { return { } },
            validator: function (classNames) {
                let valid = true
                Object.keys(classNames).forEach(elementName => {
                    valid = valid && ['default', 'hover', 'hoverMask'].indexOf(elementName) > -1
                })
                return valid
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.link-hover
    position: relative
    display: inline-block
    overflow: hidden
button.link-hover
    height: auto
    cursor: pointer
.link-hover_default
    position: relative
    display: flex
    height: 100%
.link-hover_hover, .link-hover_mask
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    display: flex
    transition: transform 0.275s ease-in-out
.link-hover_hover
    overflow: hidden
    transform: translateY(101%)
.link-hover_mask
    transform: translateY(-101%)
.link-hover.is-hover
    .link-hover_hover
        transform: none
        will-change: transform
    .link-hover_mask
        transform: none
        will-change: transform

// @media not all and (pointer: coarse)
.link-hover.is-hover-enable:hover,
a:hover .link-hover.is-hover-enable,
button:hover .link-hover.is-hover-enable
    .link-hover_hover
        transform: translateY(0%)
        will-change: transform
    .link-hover_mask
        transform: translateY(0%)
</style>
